import { IDataRequest, IDataResponse, IHttpClient, STATUS_CODE } from "../providers/api";

export interface Parametro {
    id?: null | String;
    entidade: string;
    atributo_id: string;
    valor: any;
    created_at?: string;
    updated_at?: string | null;
}

class ConfiguracaoStore {

    private url: string;

    constructor(private readonly client: IHttpClient, private readonly path: string) {
        this.url = `/parametros/${path}`
    }

    async list(): Promise<Parametro[]> {
        const request: IDataRequest = { url: this.url }
        const response: IDataResponse = await this.client.get(request)
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data as Parametro[]
        }

        return []
    }

    async save(parametros: Parametro[]): Promise<boolean> {
        const data: any = parametros.map((p) => {
            if (p.valor === "") {
                p.valor = null
            }
            return { atributo_id: p.atributo_id, valor: p.valor }
        })
        const request: IDataRequest = { url: this.url, data: data }
        const response: IDataResponse = await this.client.post(request)
        if (response.statusCode === STATUS_CODE.OK) {
            return true
        }
        return false
    }
}

export { ConfiguracaoStore }